import {
  ArrowDownTrayIcon,
  HeartIcon as AB,
  UserIcon,
  ChevronUpDownIcon,
  XCircleIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import {
  addCmt,
  checkPhoneChu,
  countTinLienQuan,
  listProductIDAllShowCount,
  listProductIDShow,
  removeCmts,
  updateBds,
} from '../../../services/apiBds';
import { Link, useParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { convertNumberToWords, getCookie, decode, encode, keepTwoDecimals } from '../../../utils/helper';
import JSZip, { remove } from 'jszip';
import { saveAs } from 'file-saver';
import { API_URL } from '../../../utils/urls';
import { BellAlertIcon, HeartIcon, MinusIcon } from '@heroicons/react/24/solid';
import {
  Alert,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Textarea,
  Typography,
} from '@material-tailwind/react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import DialogBds from '../../../components/DialogBds';
import { historysUser } from '../../../utils/history';
import LoadingFrame from '../../../components/loadingFrame';
import { listAllYeuthich, listIdYeuthich } from '../../../services/apiYeuthich';
import avt from '../../../assets/images/avt.png';
import FrameShowBds from '../../../components/FrameShowBds';
import { listAllLoaibds, listAllVitri } from '../../../services/apiCategory';
import SafeText from '../../../components/SafeText';
import { isAdmin, isBdsStatus, isOldData } from '../../../utils/permissions';

export default function BdsDetail() {
  const arrSapxep = [
    { title: 'Sắp xếp thứ tự: Giá m2, DT...', value: '1' },

    // { title: 'Cập nhật: Mới đây', value: '2' },
    // { title: 'Cập nhật: Cũ trước', value: '3' },
    // { title: 'Tổng giảm giá', value: '4' },

    // // { title: 'Giá m2 thấp hơn TT-KV-PK', value: '6' },
    // { title: 'Thu nhập cao', value: '7' },
    // { title: 'Đường trước nhà', value: '8' },
    { title: 'Giá: Giảm dần', value: '10' },
    { title: 'Giá: Tăng dần', value: '11' },
    { title: 'Giá m2 thấp', value: '5' },
    { title: 'Số Tầng', value: '9' },
    // { title: 'Ngày: cũ trước', value: '12' },
    // { title: 'Ngày: mới nhất', value: '13' },
    { title: 'Ngang lớn', value: '14' },
    // { title: 'Ngang nhỏ trước', value: '15' },
    // { title: 'Dài - Giảm dần', value: '16' },
    // { title: 'Dài - Tăng dần', value: '17' },
    { title: 'Diện tích lớn', value: '18' },
    // { title: 'DTXD (thổ cư)', value: '19' },
    { title: 'Ngẫu nhiên', value: '' },
  ];

  let listVaiTro = [
    { id: 1, name: 'Người đứng tên', value: 'Người đứng tên' },
    { id: 2, name: 'Con ruột', value: 'Con ruột' },
    { id: 3, name: 'Cha/mẹ', value: 'Cha/mẹ' },
    ,
    { id: 4, name: 'Anh/em', value: 'Anh/em' },
    ,
    { id: 5, name: 'Họ hàng', value: 'Họ hàng' },
    ,
    { id: 6, name: 'Người quyết định (không đứng tên)', value: 'Người quyết định (không đứng tên)' },
    ,
    { id: 7, name: 'Môi giới độc quyền', value: 'Môi giới độc quyền' },
    ,
    { id: 8, name: 'Chưa xác định', value: 'Chưa xác định' },
  ];
  const inputFile = useRef(null);
  const inputFileQhxd = useRef(null);
  const inputFileSo = useRef(null);
  const auth = getCookie('token');
  const params = useParams();
  const [showImage, setShowImage] = useState([]);
  const [message, setMessage] = useState(false);
  const [resultListBds, setResultListBds] = useState({});
  const [arrOptionSelect, setArrOptionSelect] = useState({});
  const [arrOptionSelectSearch, setArrOptionSelectSearch] = useState({});
  const [arrBDS, setArrBDS] = useState({
    gia: '',
    noidung: '',
    id_bds: decode(params.id),
    id_user: auth?.id,
    sdtchudat: '',
    sdtchudatvaitro: '',
    anh: '',
    anhso: '',
    nhaclich: '',
    loaivitri: '',
    loaibds: '',
    dientich: '',
    dientichdatnn: '',
    sophong: '',
    sotang: '',
    qhxd: '',
    status: 1,
  });
  const [loading, setLoading] = useState(false);
  const [resultYT, setResultYT] = useState([]);
  const [resultTuongtu, setResultTuongtu] = useState([]);
  const [resultGanVitri, setResultGanVitri] = useState([]);
  const [showImageViTri, setShowImageViTri] = useState([]);
  const [showImagesViTri, setShowImagesViTri] = useState([]);
  const [showImageTuongtu, setShowImageTuongtu] = useState([]);
  const [showImagesTuongtu, setShowImagesTuongtu] = useState([]);
  const [openComment, setOpenComment] = useState({
    one: false,
    two: false,
    three: false,
    four: false,
    five: false,
    six: false,
  });
  const [images, setImages] = useState([]);
  const [imagesQhxd, setImagesQhxd] = useState([]);
  const [imageURLS, setImageURLs] = useState([]);
  const [imageURLSQhxd, setImageURLsQhxd] = useState([]);
  const [imagesSo, setImagesSo] = useState([]);
  const [imageURLSSo, setImageURLsSo] = useState([]);
  const [giaCmt, setGiaCmt] = useState(0);
  const [discountCmt, setDiscountCmt] = useState('');
  const [objImageDetail, setObjImageDetail] = useState({ id: '', url: '' });
  const [isYeuThich, setIsYeuThich] = useState([]);
  const [open, setOpen] = useState(0);
  const [isChangeData, setIsChangeData] = useState({});
  const [openMap, setOpenMap] = useState(false);
  const [phuonggroup, setPhuonggroup] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [warningMessagePhone, setWarningMessagePhone] = useState('');
  const handleOpenMap = () => setOpenMap(!openMap);

  const listBdsAll = async (pages = 1, code = '') => {
    const resultBDSAll = await listProductIDShow(pages, '', code);
    if (resultBDSAll.length > 0) {
      fetchImages(resultBDSAll[0]['anhto']);
      setResultListBds(resultBDSAll[0]);
      const gia = resultBDSAll[0]?.bl?.filter((record) => parseFloat(record.gia) > 0);
      if (gia.length > 0) {
        setGiaCmt(gia[0]['gia']);
        // console.log(gia[0]['gia']);
        const discountPercentage = resultBDSAll[0]['gia']
          ? parseFloat(resultBDSAll[0]['gia']) > gia[0]['gia']
            ? 'THẤP hơn ' + Math.round(((resultBDSAll[0]['gia'] - gia[0]['gia']) / resultBDSAll[0]['gia']) * 100) + '%'
            : 'TĂNG hơn ' + Math.round(((gia[0]['gia'] - resultBDSAll[0]['gia']) / resultBDSAll[0]['gia']) * 100) + '%'
          : '';
        setDiscountCmt(discountPercentage);
      }
      // console.log(resultListBds);
      setTimeout(() => {
        countTinLienQuanTuongTu('', resultBDSAll[0]['gia'], resultBDSAll[0]['loaibds']);
      }, 3000);

      historysUser({
        id_bds: decode(params.id),
        truong: 'xemchitiet',
        noidung: '1',
      });
      setLoading(false);
    } else {
      setResultListBds([]);
      setLoading(true);
    }
  };

  const fetchImages = async (imageNames) => {
    const res = await fetch(`${API_URL}/imgshop-batch?names=${imageNames}`);
    const data = await res.json();
    setShowImage(data);
  };

  const listAllYeuThich = async () => {
    const resultAPI = await listIdYeuthich(decode(params.id), auth?.id);
    if (resultAPI.length > 0) {
      setResultYT(resultAPI[0]);
    }
  };

  const listAllYeuThichTuongTu = async (pages = 1) => {
    const resultAPI = await listAllYeuthich(pages, '', auth?.id);
    if (resultAPI.length > 0) {
      setIsYeuThich(resultAPI);
    }
  };
  useEffect(() => {
    if (params.id) {
      listBdsAll(1, decode(params.id));
      listAllYeuThich();
      listAllYeuThichTuongTu();
    }
  }, []);

  const downloadImagesAsZip = (arrImage, namezip) => {
    const zip = new JSZip();
    const imageUrls = arrImage?.split(',').length > 0 ? arrImage?.split(',') : [];

    const promises = imageUrls.map((imageUrl, index) => {
      return fetch(`${API_URL}/imgshop?name=${imageUrl}`)
        .then((response) => response.blob())
        .then((blob) => {
          zip.file(imageUrl, blob);
        });
    });

    Promise.all(promises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        saveAs(content, namezip + '.zip');
      });
    });
  };

  const downloadImagesAll = (arrImage) => {
    const imageUrls = arrImage?.length > 0 ? arrImage : [];
    historysUser({
      id_bds: resultListBds?.id,
      truong: 'taihinh',
      noidung: imageUrls.length,
    });

    imageUrls.map((imageUrl, index) => {
      return fetch(`${imageUrl.base64}`)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, `${index + 1}_${Date.now()}`);
        });
    });
  };

  const downloadImage = (imageURL, index) => {
    saveAs(imageURL, `${index + 1}_${Date.now()}`);
    historysUser({
      id_bds: resultListBds?.id,
      truong: 'taihinh',
      noidung: '1',
    });
  };

  // HÌNH ẢNH
  const onButtonClickFileImage = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };
  const onButtonClickFileImageQhxd = () => {
    // `current` points to the mounted file input element
    inputFileQhxd.current.click();
  };

  const onFilechange = (e) => {
    let tempArr = [];
    let tempFileArr = [];
    if (images.length + resultListBds.anhto?.split(',').length + e.target.files.length > 20) {
      alert('Bạn chỉ được thêm tối đa 20 ảnh');
      return;
    }
    [...e.target.files].forEach((file) => {
      if (file.type.startsWith('image/')) {
        tempArr.push(URL.createObjectURL(file));
        tempFileArr.push(file);
      } else {
        alert('Bạn không được thêm video hoặc tập tin');
        return;
      }
    });
    setImageURLs([...imageURLS, ...tempArr]);
    setImages([...images, ...tempFileArr]);
  };

  // xoa ảnh
  const removeImage = (index) => {
    const arrRemove = imageURLS.filter((_, i) => i !== index) || [];
    const arrRemoveFile = images.filter((_, i) => i !== index) || [];
    setImageURLs(arrRemove);
    setImages(arrRemoveFile);
  };

  const onFilechangeQHXD = (e) => {
    let tempArr = [];
    let tempFileArr = [];
    if (images.length + resultListBds.anh_qhxd?.split(',').length + e.target.files.length > 4) {
      alert('Bạn chỉ được thêm tối đa 4 ảnh');
      return;
    }
    [...e.target.files].forEach((file) => {
      if (file.type.startsWith('image/')) {
        tempArr.push(URL.createObjectURL(file));
        tempFileArr.push(file);
      } else {
        alert('Bạn không được thêm video hoặc tập tin');
        return;
      }
    });
    setImageURLsQhxd([...imageURLSQhxd, ...tempArr]);
    setImagesQhxd([...imagesQhxd, ...tempFileArr]);
  };

  // xoa ảnh
  const removeImageQHXD = (index) => {
    const arrRemove = imageURLSQhxd.filter((_, i) => i !== index) || [];
    const arrRemoveFile = imagesQhxd.filter((_, i) => i !== index) || [];
    setImageURLsQhxd(arrRemove);
    setImagesQhxd(arrRemoveFile);
  };

  // HÌNH ẢNH SỔ
  const onButtonClickFileImageSo = () => {
    // `current` points to the mounted file input element
    inputFileSo.current.click();
  };

  const onFilechangeSo = (e) => {
    let tempArr = [];
    let tempFileArr = [];
    if (imagesSo.length + resultListBds.anhthua?.split(',').length + e.target.files.length > 5) {
      alert('Bạn chỉ được thêm tối đa 5 ảnh hoặc tập tin');
      return;
    }
    [...e.target.files].forEach((file) => {
      if (file.type.startsWith('image/')) {
        tempArr.push(URL.createObjectURL(file));
        tempFileArr.push(file);
      } else if (file.type.startsWith('video/')) {
        alert('Bạn không được thêm video');
        return;
      } else {
        tempArr.push('');
        tempFileArr.push(file);
      }
    });
    setImageURLsSo([...imageURLSSo, ...tempArr]);
    setImagesSo([...imagesSo, ...tempFileArr]);
  };

  // xoa ảnh
  const removeImageSo = (index) => {
    const arrRemove = imageURLSSo.filter((_, i) => i !== index) || [];
    const arrRemoveFile = imagesSo.filter((_, i) => i !== index) || [];
    setImageURLsSo(arrRemove);
    setImagesSo(arrRemoveFile);
  };

  const filterValidObjects = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string' && value.trim() === '') return false;
        if (Array.isArray(value) && value.length === 0) return false;
        if (typeof value === 'object' && Object.keys(value).length === 0) return false;
        return true;
      }),
    );
  };

  const subComment = async () => {
    const checkphone = await checkPhoneSDTChu(
      arrBDS.sdtchudat,
      resultListBds?.soto,
      resultListBds?.sothua,
      resultListBds?.xa,
    );
    if (checkphone && openComment.three) {
      console.log('Số điện thoại này đã tồn tại trong hệ thống');
    } else {
      if (arrBDS.sdtchudatvaitro === '' && openComment.three) {
        alert(`Chưa chọn vai trò sđt`);
        return;
      }
      const formData = new FormData();

      let arrAnhTo = [];
      let arrAnhThua = [];
      let arrAnhQHXD = [];
      if (images.length > 0) {
        images.forEach((image, i) => {
          const extension = image.name.split('.').pop();
          let timestamp = i + '_img_' + Date.now() + '.' + extension;
          arrAnhTo.push(timestamp);
          formData.append('image', image, timestamp);
        });
      }
      if (imagesQhxd.length > 0) {
        imagesQhxd.forEach((image, i) => {
          let extension = image.name?.split('.').pop().toLowerCase() || 'jpg';

          // Chuẩn hóa extension
          const validExtensions = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
          if (extension === 'jfif') {
            extension = 'jpg';
          } else if (!validExtensions.includes(extension)) {
            extension = 'jpg'; // fallback nếu đuôi không hợp lệ
          }

          const timestamp = `${i}_qhxd_${Date.now()}.${extension}`;
          arrAnhQHXD.push(timestamp);
          formData.append('image', image, timestamp);
        });
      }

      if (imagesSo.length > 0) {
        imagesSo.forEach((image, i) => {
          const extension = image.name.split('.').pop();
          let timestamp = i + '_to_' + Date.now() + '.' + extension;
          arrAnhThua.push(timestamp);
          formData.append('image', image, timestamp);
        });
      }
      const arr = {
        gia: arrBDS.gia * 1000000000,
        noidung: arrBDS.noidung,
        sdtchudat: openComment.three ? arrBDS.sdtchudat : '',
        sdtchudatvaitro: openComment.three ? arrBDS.sdtchudatvaitro : 'Người đứng tên',
        nhaclich: openComment.four ? arrBDS.nhaclich : '',
        anh: openComment.one ? arrAnhTo.join(',') : '',
        anhso: openComment.two ? arrAnhThua.join(',') : '',
        status: 1,
        id_bds: decode(params.id),
        id_user: auth?.id,
        sotang: openComment.five ? (arrBDS.sotang ? arrBDS.sotang : '') : '',
        sophong: openComment.five ? (arrBDS.sophong ? arrBDS.sophong : '') : '',
        dientich: openComment.five ? (arrBDS.dientich ? arrBDS.dientich : '') : '',
        dientichdatnn: openComment.five ? (arrBDS.dientichdatnn ? arrBDS.dientichdatnn : '') : '',
        loaivitri: openComment.five ? (arrBDS.loaivitri ? arrBDS.loaivitri : '') : '',
        loaibds: openComment.five ? (arrBDS.loaibds ? arrBDS.loaibds : '') : '',
        qhxd: arrBDS.qhxd ? (arrBDS.qhxd ? arrBDS.qhxd : '') : '',
        anh_qhxd: openComment.six ? arrAnhQHXD.join(',') : '',
      };
      formData.append('data', JSON.stringify(filterValidObjects(arr)));
      let arrBDSSV = {
        id: decode(params.id),
        thoihan: openComment.four ? arrBDS.nhaclich : resultListBds.thoihan,
        anhto: openComment.one ? [...arrAnhTo, ...(resultListBds.anhto?.split(',') || [])].join(',') : '',
        anhthua: openComment.two ? [...arrAnhThua, ...(resultListBds.anhthua?.split(',') || [])].join(',') : '',
        sotang: openComment.five ? (arrBDS.sotang ? arrBDS.sotang : '') : '',
        sophong: openComment.five ? (arrBDS.sophong ? arrBDS.sophong : '') : '',
        dientich: openComment.five ? (arrBDS.dientich ? arrBDS.dientich : '') : '',
        dientichdatnn: openComment.five ? (arrBDS.dientichdatnn ? arrBDS.dientichdatnn : '') : '',
        loaivitri: openComment.five ? (arrBDS.loaivitri ? arrBDS.loaivitri : '') : '',
        loaibds: openComment.five ? (arrBDS.loaibds ? arrBDS.loaibds : '') : '',
      };

      const result = await updateBds({ data: JSON.stringify(filterValidObjects(arrBDSSV)) });
      if (result.message === 'OK') {
        const upload = await addCmt(formData);
        if (upload.message === 'OK') {
          setImageURLs([]);
          setImageURLsSo([]);
          setImages([]);
          setImageURLsSo([]);
          setMessage(true);
          setTimeout(() => {
            setMessage(false);
          }, 3000);
          setArrBDS({
            gia: '',
            noidung: '',
            id_bds: decode(params.id),
            id_user: auth?.id,
            sdtchudat: '',
            sdtchudatvaitro: '',
            anh: '',
            anhso: '',
            nhaclich: '',
            loaivitri: '',
            loaibds: '',
            dientich: '',
            dientichdatnn: '',
            sophong: '',
            sotang: '',
            qhxd: '',
            status: 1,
          });
          setOpenComment({ one: false, two: false, three: false, four: false, five: false });
          listBdsAll(1, decode(params.id));
        }
      }
    }
  };

  const subIsMuaBan = async (status) => {
    const formData = new FormData();
    let arrBDSSV = {
      id: decode(params.id),
      status: status,
    };
    let arr = {
      id_bds: decode(params.id),
      noidung: status === '1' ? 'Còn bán' : status === '5' ? 'Ngưng bán' : status === '6' ? 'Không hề bán' : 'Đã bán',
      status: status,
      id_user: auth?.id,
    };
    formData.append('data', JSON.stringify(filterValidObjects(arr)));
    const result = await updateBds({ data: JSON.stringify(arrBDSSV) });
    if (result.message === 'OK') {
      const upload = await addCmt(formData);
      if (upload.message === 'OK') {
        setMessage(true);
        listBdsAll(1, decode(params.id));
        setTimeout(() => {
          setMessage(false);
        }, 3000);
      }
    }
  };
  const countTinLienQuanTuongTu = async (status, gia, loaibds) => {
    let giastart = gia && !isNaN(gia) ? gia && gia * 0.8 : '';
    let giaend = gia && !isNaN(gia) ? gia && gia / 0.8 : '';
    // const result = await countTinLienQuan(duong, huyen, giastart, giaend, '', '', loaibds, loaivitri);
    const result = await listProductIDShow(
      1,
      status,
      '',
      '',
      loaibds,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      `${giastart !== 0 ? giastart : 0},${giaend !== '' ? giaend : ''}`,
    );
    if (result.length > 0) {
      // console.log(result);

      setResultTuongtu(result);
      // const filteredData = result.map((item) => {
      //   if (!item.anhto) return ''; // Nếu anhto là chuỗi rỗng
      //   const parts = item.anhto.split(',').map((s) => s.trim()); // Tách chuỗi và loại bỏ khoảng trắng
      //   return parts[0] || ''; // Trả về ảnh đầu tiên hoặc chuỗi rỗng
      // });

      const filteredDataDetail = result.map((item) => {
        if (!item.anhto) return ''; // Nếu anhto là chuỗi rỗng
        const parts = item.anhto.split(',').map((s) => s.trim()); // Tách chuỗi và loại bỏ khoảng trắng
        return parts || ''; // Trả về ảnh đầu tiên hoặc chuỗi rỗng
      });

      // await fetchImagesTuongtu(filteredData.join(','));
      setShowImagesTuongtu(filteredDataDetail);
      countTinLienQuanGanViTri('', resultListBds['gia'], resultListBds['xa']);
      const countBds = await listProductIDAllShowCount(
        status,
        '',
        '',
        loaibds,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        `${giastart !== 0 ? giastart : 0},${giaend !== '' ? giaend : ''}`,
      );
      // console.log(countBds);
    } else {
      setTimeout(() => {
        countTinLienQuanGanViTri('', resultListBds['gia'], resultListBds['xa']);
      }, 5000);
      setResultTuongtu([]);
    }
  };

  const countTinLienQuanGanViTri = async (status, gia, xa) => {
    let giastart = gia && !isNaN(gia) ? gia && gia * 0.8 : '';
    let giaend = gia && !isNaN(gia) ? gia && gia / 0.8 : '';
    const result = await listProductIDShow(
      1,
      status,
      '',
      '',
      '',
      xa,
      '',
      '',
      '',
      '',
      '',
      '',
      `${giastart !== 0 ? giastart : 0},${giaend !== '' ? giaend : ''}`,
    );
    if (result.length > 0) {
      // console.log(result);
      // const filteredData = result.map((item) => {
      //   if (!item.anhto) return ''; // Nếu anhto là chuỗi rỗng
      //   const parts = item.anhto.split(',').map((s) => s.trim()); // Tách chuỗi và loại bỏ khoảng trắng
      //   return parts[0] || ''; // Trả về ảnh đầu tiên hoặc chuỗi rỗng
      // });

      const filteredDataDetail = result.map((item) => {
        if (!item.anhto) return ''; // Nếu anhto là chuỗi rỗng
        const parts = item.anhto.split(',').map((s) => s.trim()); // Tách chuỗi và loại bỏ khoảng trắng
        return parts || ''; // Trả về ảnh đầu tiên hoặc chuỗi rỗng
      });

      // fetchImagesVitri(filteredData.join(','));
      setShowImagesViTri(filteredDataDetail);
      setResultGanVitri(result);
      const countBds = await listProductIDAllShowCount(
        status,
        '',
        '',
        '',
        xa,
        '',
        '',
        '',
        '',
        '',
        '',
        `${giastart !== 0 ? giastart : 0},${giaend !== '' ? giaend : ''}`,
      );
      // console.log(countBds);
    } else {
      setResultGanVitri([]);
    }
  };

  const fetchImagesTuongtu = async (imageNames) => {
    const res = await fetch(`${API_URL}/imgshop-thumbnail?names=${imageNames}`);
    const data = await res.json();
    // console.log(data);
    setShowImageTuongtu(data);
  };

  const fetchImagesVitri = async (imageNames) => {
    const res = await fetch(`${API_URL}/imgshop-thumbnail?names=${imageNames}`);
    const data = await res.json();
    // console.log(data);
    setShowImageViTri(data);
  };

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  const getLoaiVitri = async () => {
    const resultAPI = await listAllVitri(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, loaivitri: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, loaivitri: resultAPI });
    }
  };

  const getLoaiBDS = async () => {
    const resultAPI = await listAllLoaibds(1, 1000);
    if (resultAPI.length > 0) {
      setArrOptionSelect({ ...arrOptionSelect, loaibds: resultAPI });
      setArrOptionSelectSearch({ ...arrOptionSelect, loaibds: resultAPI });
    }
  };

  const removeDataBds = (data, key, index) => {
    const updatedData = data.filter((item, i) => i !== index);
    setArrBDS({
      ...arrBDS,
      [key]: updatedData.join(','),
    });
  };

  const handleSearchOptionSelect = (key, val, keysearch) => {
    if (val) {
      const results = arrOptionSelect[key].filter((item) => item[keysearch].toLowerCase().includes(val.toLowerCase()));
      setArrOptionSelectSearch({ ...arrOptionSelect, [key]: results });
    } else {
      setArrOptionSelectSearch({ ...arrOptionSelect, [key]: arrOptionSelect[key] });
    }
  };
  const checkText = (data1, data2) => {
    const textArray1 = data1.split(','); // Split data1 into an array
    const textArray2 = data2.split(','); // Split data2 into an array

    const isMatch = textArray1.some((text) => textArray2.includes(text));

    return isMatch;
  };

  const findPhuongGroup = (xaText) => {
    const data = arrOptionSelectSearch?.streets;
    if (!xaText || !Array.isArray(data)) return null;

    const cleanXa = xaText.trim().toLowerCase();

    const found = data.find((item) => item.xa.trim().toLowerCase() === cleanXa);
    return found?.phuong_group || '';
  };

  const removeCmt = async (id) => {
    console.log(id);
    if (window.confirm('Bạn Chắc Chắn muốn xóa bình luận này')) {
      // Save it!
      const body = {
        id: id,
      };
      const resultAPI = await removeCmts(body);
      if (resultAPI?.message === 'OK') {
        listBdsAll(1, decode(params.id));
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const validatePhoneNumber = (text) => {
    // const match = text?.match(/^\d{10}/); // Kiểm tra 10 chữ số đầu tiên của chuỗi
    // return match !== null;
    return /^\d{10}/.test(text?.trim() ?? '');
  };

  const checkPhoneSDTChu = async (phone, textSoTo, textSoThua, textXa) => {
    if (validatePhoneNumber(phone)) {
      try {
        const result = await checkPhoneChu(phone.slice(0, 10), textSoTo, textSoThua, textXa);

        // console.log(result);
        if (result.length > 0) {
          setWarningMessagePhone('Số điện thoại này đã tồn tại trong hệ thống');
          return true;
        } else {
          setWarningMessagePhone('');
          return false;
        }
      } catch (error) {
        console.error('Lỗi khi check SĐT:', error);
      }
    } else {
      setWarningMessagePhone('Bạn nhập số điện thoại không đủ 10 số');
      return true;
    }
  };
  return (
    <div className="container mx-auto">
      <Dialog open={openMap} handler={handleOpenMap}>
        <DialogHeader>Vị Trí BĐS</DialogHeader>
        <DialogBody>
          {resultListBds?.toado && (
            <iframe
              src={resultListBds?.toado}
              width="100%"
              height="450"
              // style="border:0;"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          )}
        </DialogBody>
        <DialogFooter>
          <Button variant="text" color="red" onClick={handleOpenMap} className="mr-1">
            Đóng
          </Button>
        </DialogFooter>
      </Dialog>
      {Object.keys(resultListBds).length > 0 ? (
        <>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
            <div className={resultListBds?.bl?.length > 0 ? `lg:col-span-6` : `lg:col-span-9`}>
              <div className="flex gap-4">
                {' '}
                <div className="flex items-center text-pink-600 font-bold">
                  {resultYT.id_bds === Number(decode(params.id)) ? (
                    <HeartIcon className="h-5 w-5" />
                  ) : (
                    <AB className="h-5 w-5" />
                  )}
                  Thích
                </div>
                <div className="font-bold">
                  Nhập lúc {resultListBds?.create_date?.split('T')[1]} - {resultListBds?.create_date?.split('T')[0]}
                </div>
                <div className="font-bold">MS: #{encode(resultListBds.id)}</div>
              </div>

              <PhotoProvider
                className="!z-[9999]"
                onIndexChange={(i) => {
                  setObjImageDetail({
                    id: i,
                    url:
                      resultListBds.anhto && resultListBds.anhto?.split(',').length > 0
                        ? `${API_URL}/imgshop?name=${resultListBds.anhto?.split(',')[i]}`
                        : '',
                  });
                }}
                toolbarRender={({ rotate, onRotate, scale, onScale }) => (
                  <div className="flex gap-3 mt-2 p-2 rounded shadow-lg ">
                    <Button onClick={() => onRotate(rotate + 90)} color="blue" size="sm">
                      Xoay
                    </Button>
                    <Button onClick={() => onScale(scale + 0.2)} color="amber" size="sm">
                      Phóng to
                    </Button>
                    <Button onClick={() => onScale(scale - 0.2)} color="yellow" size="sm">
                      Thu nhỏ
                    </Button>
                    <Button
                      color="green"
                      size="sm"
                      onClick={() => downloadImage(objImageDetail.url, objImageDetail.id)}
                    >
                      Tải về
                    </Button>
                  </div>
                )}
              >
                {(resultListBds?.ishanche === 2 ||
                  resultListBds?.isdocquyen === 1 ||
                  resultListBds?.ishanche === 1 ||
                  (giaCmt > 0 ? giaCmt >= 50000000000 : resultListBds?.gia >= 50000000000)) &&
                  !isAdmin(auth) && (
                    <div className="flex justify-center ">
                      <span className="bg-orange-50 text-purple-800 p-2 mt-1 font-bold font-sans">KHÔNG ĐƯỢC GỌI</span>
                    </div>
                  )}

                <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 mt-5 ">
                  {showImage &&
                    showImage.length > 0 &&
                    showImage.map((imageSrc, i) => (
                      <figure className="relative w-full" key={i}>
                        <PhotoView src={`${imageSrc.base64}`}>
                          <LazyLoadImage
                            alt={'không có ảnh'}
                            width={'100%'}
                            effect="blur"
                            src={`${imageSrc.base64}`}
                            className=" border hover:border-amber-500 hover:border-dashed p-1 rounded-2xl cursor-pointer"
                            onClick={() => {
                              setObjImageDetail({ id: i, url: `${imageSrc.base64}` });
                            }}
                          />
                        </PhotoView>

                        <figcaption className="absolute top-[5px] left-[29px] flex px-1 -translate-x-2/4 justify-center border border-white bg-white text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm rounded-lg">
                          <div
                            className="flex items-center cursor-pointer"
                            onClick={() => downloadImage(`${imageSrc.base64}`, i)}
                          >
                            <ArrowDownTrayIcon className="w-5 h-5 text-orange-600" />
                            <span className="text-orange-600 text-xs ml-1"> #{i + 1}</span>
                          </div>
                        </figcaption>
                      </figure>
                    ))}
                </div>
              </PhotoProvider>
              {showImage && (
                <div className="flex justify-center">
                  <div
                    className="flex items-center cursor-pointer p-2 bg-orange-500 text-gray-900 font-bold rounded-xl hover:bg-green-300"
                    onClick={() => downloadImagesAll(showImage)}
                  >
                    <ArrowDownTrayIcon className="w-5 h-5" />
                    <span className="ml-1">Tải về tất cả</span>
                  </div>
                </div>
              )}

              <div className="mt-4 leading-7">
                <p className="font-bold">
                  {`${resultListBds.loaibds ? resultListBds?.loaibds : ''}${
                    resultListBds.loaivitri ? ' - ' + resultListBds?.loaivitri : ''
                  }${
                    resultListBds.sotang !== '0'
                      ? (resultListBds?.sotang ? ' - ' + resultListBds?.sotang + ' tầng' : '') +
                        (resultListBds.sophong !== '0'
                          ? (resultListBds?.sophong ? ' - ' + resultListBds?.sophong + ' phòng' : '') +
                            (resultListBds.sowc ? ' - ' + resultListBds?.sowc + ' WC' : '')
                          : '')
                      : ''
                  }${resultListBds.phaply ? ' - ' + resultListBds?.phaply : ''}${
                    resultListBds.duong
                      ? ' - đường ' +
                        resultListBds?.duong +
                        ', ' +
                        resultListBds?.xa +
                        (phuonggroup ? ` (${phuonggroup})` : '') +
                        ', ' +
                        resultListBds?.huyen
                      : ''
                  }${resultListBds.rongduong ? ', đường trước nhà ' + resultListBds?.rongduong + 'm' : ''}.#${encode(
                    resultListBds.id,
                  )}`}
                </p>
                <div className=" font-sans">
                  {' '}
                  <p>
                    {resultListBds?.dientich &&
                    resultListBds.dientichdatnn &&
                    resultListBds.dientichdatnn !== null &&
                    resultListBds.dientichdatnn !== '0'
                      ? '\n👉 Diện tích: ' +
                        keepTwoDecimals(
                          parseFloat(resultListBds?.dientich || 1) + parseFloat(resultListBds?.dientichdatnn || 0),
                        ) +
                        'm2' +
                        ` (${
                          resultListBds?.dientich && resultListBds?.dientich !== '0'
                            ? resultListBds?.dientich + ' m2 thổ cư'
                            : ''
                        },${resultListBds?.dientichdatnn ? resultListBds?.dientichdatnn + ' m2 đất nông nghiệp' : ''} )`
                      : ''}
                    {resultListBds?.dientich &&
                    (resultListBds.dientichdatnn === '0' ||
                      resultListBds.dientichdatnn === null ||
                      resultListBds.dientichdatnn === '')
                      ? '\n👉 Diện tích: ' +
                        resultListBds?.dientich +
                        'm2' +
                        (resultListBds?.ngang ? ', ngang ' + resultListBds?.ngang + 'm' : '')
                      : ''}
                  </p>
                  <p>
                    {resultListBds.sotang !== '0'
                      ? '👉 Kết cấu: ' +
                        (resultListBds?.sotang ? resultListBds?.sotang + ' tầng' : '') +
                        (resultListBds.sophong !== '0'
                          ? (resultListBds?.sophong ? ' - ' + resultListBds?.sophong + ' phòng' : '') +
                            (resultListBds.sowc ? ' - ' + resultListBds?.sowc + ' WC' : '')
                          : '')
                      : ''}
                  </p>
                  <p>{resultListBds?.quyhoach ? '👉 Quy hoạch: ' + resultListBds?.quyhoach : ''}</p>
                  <p>{resultListBds?.phaply ? '👉 Pháp lý: ' + resultListBds?.phaply : ''}</p>
                  <p>
                    {resultListBds?.huongbds
                      ? (() => {
                          const huong = resultListBds.huongbds;

                          if (
                            huong.includes('Đông Tứ Trạch') ||
                            huong.includes('Tây Tứ Trạch') ||
                            huong.includes('Không Xác Định')
                          ) {
                            return '👉 Hướng: ' + huong;
                          }

                          const arr = huong.split(',').map((i) => i.trim());

                          const dongTuTrach = ['Đông', 'Đông Nam', 'Nam', 'Bắc'];
                          const tayTuTrach = ['Tây', 'Tây Bắc', 'Tây Nam', 'Đông Bắc'];

                          if (arr.some((h) => dongTuTrach.includes(h))) {
                            return '👉 Hướng: ' + huong + ', Đông Tứ Trạch';
                          }

                          if (arr.some((h) => tayTuTrach.includes(h))) {
                            return '👉 Hướng: ' + huong + ', Tây Tứ Trạch';
                          }

                          return '👉 Hướng: ' + huong;
                        })()
                      : ''}
                  </p>
                  <p>{resultListBds.dientichsan ? '👉 Tổng diện tích sàn ' + resultListBds?.dientichsan + 'm2' : ''}</p>
                  <p>
                    {resultListBds?.dactrung || resultListBds?.tiennghi || resultListBds?.notekhach
                      ? '👉 Mô tả: ' +
                        (resultListBds?.tiennghi ? ' - ' + resultListBds?.tiennghi : '') +
                        (resultListBds?.dactrung ? ' - ' + resultListBds?.dactrung : '')
                      : ''}
                  </p>
                  {/* 123 {resultListBds?.toado} */}
                  {resultListBds?.toado ? (
                    <span className="text-blue-500 underline cursor-pointer" onClick={handleOpenMap}>
                      {' '}
                      👉 Vị trí toạ độ Bđs
                    </span>
                  ) : (
                    ''
                  )}
                </div>
                <SafeText className="font-sans" text={resultListBds?.notekhach} />

                <div className="mt-5 lg:flex lg:items-center">
                  {isBdsStatus(resultListBds.status, 2) ? (
                    <p className="font-bold text-red-700 font-sans ml-1">
                      Đã Bán -{' '}
                      {giaCmt > 0
                        ? convertNumberToWords(giaCmt)
                        : convertNumberToWords(resultListBds?.gia ? resultListBds?.gia : '')}
                    </p>
                  ) : resultListBds.status === '5' ? (
                    <p className="font-bold text-red-700 font-sans ml-1">Ngưng bán</p>
                  ) : resultListBds.status === '6' ? (
                    <p className="font-bold text-red-700 font-sans ml-1">Không hề bán</p>
                  ) : (
                    <p className="font-bold text-green-700 font-sans ml-1">
                      {giaCmt > 0
                        ? convertNumberToWords(giaCmt)
                        : convertNumberToWords(resultListBds?.gia ? resultListBds?.gia : '')}{' '}
                      {giaCmt > 0
                        ? resultListBds?.dientich || resultListBds?.dientichdatnn
                          ? `- ${convertNumberToWords(
                              parseInt(giaCmt) /
                                (parseInt(resultListBds?.dientich || 1) + parseInt(resultListBds?.dientichdatnn || 0)),
                            )}/m2`
                          : ''
                        : resultListBds?.gia && (resultListBds?.dientich || resultListBds?.dientichdatnn)
                          ? `- ${convertNumberToWords(
                              parseInt(resultListBds?.gia) /
                                (parseInt(resultListBds?.dientich || 1) + parseInt(resultListBds?.dientichdatnn || 0)),
                            )}/m2`
                          : ''}
                      <span className="font-light text-gray-900">
                        {giaCmt > 0 && resultListBds?.gia
                          ? parseInt(resultListBds?.gia) > parseInt(giaCmt)
                            ? ` (đã giảm ${convertNumberToWords(parseInt(resultListBds?.gia) - parseInt(giaCmt))})`
                            : ` (đã tăng ${convertNumberToWords(parseInt(giaCmt) - parseInt(resultListBds?.gia))})`
                          : ''}{' '}
                      </span>
                      <br />
                      <span className="font-bold text-teal-800">
                        {' '}
                        {resultListBds?.giathue > 0 && 'Giá thuê: ' + convertNumberToWords(resultListBds?.giathue)}{' '}
                      </span>
                      <span className="font-thin text-black">- MS: #{encode(resultListBds.id)} </span>
                    </p>
                  )}
                  {discountCmt && <p className="font-bold text-green-700">| {discountCmt}</p>}
                  <Link
                    to={`/bang-gia-m2?lbs=${resultListBds?.loaibds}&lvt=${resultListBds?.loaivitri}&d=${resultListBds?.duong}&h=${resultListBds?.huyen}&gia=${resultListBds?.gia}&dt=${resultListBds?.dientich}`}
                    target="_blank"
                  >
                    <p className="hover:underline hover:text-blue-500 cursor-pointer font-sans">
                      {resultListBds?.tlq?.totalRow > 0
                        ? ` | ${convertNumberToWords(
                            parseInt(resultListBds?.tlq?.price) / parseInt(resultListBds?.tlq?.dt),
                          )}/m2 (${resultListBds?.tlq?.totalRow} bđs)`
                        : ''}
                    </p>
                  </Link>
                </div>
              </div>

              {resultListBds?.notenoibo && (
                <>
                  {' '}
                  <hr className="my-2 border-blue-gray-50" />
                  <SafeText
                    className="text-black text-sm"
                    text={resultListBds?.notenoibo}
                    prefix="👉 Ghi chú (nội bộ): "
                  />
                </>
              )}

              <div className="flex mt-2">
                <DialogBds data={resultListBds} showImages={resultListBds.anhto} />
              </div>
              <hr className="my-2 border-blue-gray-50" />
              <div className="mt-10 text-center">
                <b>
                  👉 Nhập bởi:{' '}
                  <b className={`${isOldData(resultListBds.is_user) ? 'text-gray-500' : ''}`}>
                    {isOldData(resultListBds.is_user)
                      ? 'OLD DATA - LH: 0869596979 - Nguyễn Thị Ngọc Bích - 47 Lý Nam Đế'
                      : `${resultListBds.name} - ${resultListBds.username}
                    ${' - 47 lý nam đế'}
                    ${resultListBds?.nameteam ? ' - ' + resultListBds?.nameteam : ''}
                    ${
                      resultListBds?.fteam === '1'
                        ? ' - F1'
                        : resultListBds?.fteam === '2'
                          ? ' - F2'
                          : resultListBds?.fteam === '3'
                            ? ' - F3'
                            : ''
                    }`}
                  </b>
                  <div className="flex justify-center mt-5">
                    {isOldData(resultListBds.is_user) ? (
                      <img
                        className="rounded-full"
                        src={avt}
                        width={'100px'}
                        height={'100px'}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = avt; // Đường dẫn ảnh mặc định
                        }}
                      />
                    ) : (
                      <img
                        className="rounded-full"
                        src={`${API_URL}/avt?name=avt_${resultListBds.id_user}.jpg`}
                        width={'100px'}
                        height={'100px'}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = avt; // Đường dẫn ảnh mặc định
                        }}
                      />
                    )}
                  </div>
                </b>
              </div>
            </div>

            <div className={`lg:col-span-3 bg-white rounded-2xl`}>
              <div
                className="border-[6px] border-gray-100 rounded-2xl"
                style={{ boxShadow: 'rgba(0, 0, 0, 0.26) 0px 5px 15px' }}
              >
                <div className="border border-dashed border-orange-500 rounded-2xl">
                  <div className="flex items-center bg-orange-400 rounded-2xl p-2 font-bold">
                    <MinusIcon className="h-5 w-5" /> Bình luận công khai
                  </div>
                  <div className="bg-white mt-2 p-2 rounded-2xl">
                    {message && (
                      <Alert
                        icon={<BellAlertIcon className="h-5 w-5" />}
                        className="rounded-none border-l-4 border-[#2ec946] bg-[#2ec946]/10 font-medium text-[#2ec946] flex items-center mb-2"
                      >
                        <b>THÊM THÀNH CÔNG</b>
                      </Alert>
                    )}
                    <div className="grid grid-cols-2 gap-2">
                      <div
                        className="p-1 bg-red-500 text-white rounded-xl text-xs text-center cursor-pointer"
                        onClick={() => subIsMuaBan('2')}
                      >
                        Đã bán?
                      </div>
                      <div
                        className="p-1 bg-orange-400 text-white rounded-xl text-xs text-center cursor-pointer"
                        onClick={() => subIsMuaBan('5')}
                      >
                        Ngưng bán?
                      </div>
                      <div
                        className="p-1 bg-black text-white rounded-xl text-xs text-center cursor-pointer"
                        onClick={() => subIsMuaBan('6')}
                      >
                        Không hề bán?
                      </div>
                      <div
                        className="p-1 bg-green-500 text-white rounded-xl text-xs text-center cursor-pointer"
                        onClick={() => subIsMuaBan('1')}
                      >
                        Còn bán?
                      </div>
                    </div>

                    <div>
                      <label className="flex items-end gap-1 text-xs mb-1 mt-5">
                        <b>Giá Bán Mới (chỉ nhập số - nếu có)</b>
                      </label>
                      <Input
                        value={arrBDS?.gia}
                        placeholder="chỉ nhập số "
                        className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                        labelProps={{
                          className: 'hidden',
                        }}
                        onChange={(e) => {
                          setArrBDS({ ...arrBDS, gia: e.target.value });
                          // console.log(e.target.value * 1000000000);
                        }}
                      />
                      {arrBDS?.gia && (
                        <b className="text-red-600 text-xs">{convertNumberToWords(arrBDS?.gia * 1000000000)}</b>
                      )}
                      <div className="text-[10px] font-bold mb-2">VD: 50,95 tỷ nhập 50.95</div>
                      <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                        <b>Nội dung (Không nhập SĐT chủ ở đây)</b>
                      </label>
                      <Textarea
                        value={arrBDS?.noidung}
                        type="text"
                        className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                        labelProps={{
                          className: 'hidden',
                        }}
                        onChange={(e) => {
                          setArrBDS({ ...arrBDS, noidung: e.target.value });
                        }}
                      />
                      <div className="text-[10px] font-bold">SĐT bên Chủ thì nhập riêng vào ô SĐT bên dưới</div>
                      <div className="text-[10px] font-bold">Có thể nhấn Ctrl+v để Dán nội dung đã Copy</div>

                      {openComment?.one && (
                        <div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>++ Thêm Hình sản phẩm ?</b>
                          </label>
                          <span className="text-sm">Chỉ hình BĐS, KHÔNG hình Sổ</span>

                          <div>
                            <input
                              type="file"
                              accept="image/*"
                              multiple
                              name="image"
                              id="file"
                              ref={inputFile}
                              style={{ display: 'none' }}
                              onChange={onFilechange}
                            />{' '}
                            <div className="grid lg:grid-cols-2 gap-4">
                              {imageURLS?.map((imageSrc, i) => (
                                <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                                  <img src={imageSrc} alt="not fount" width={'100%'} />
                                  <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                                    <div>
                                      <span onClick={() => removeImage(i)} className="cursor-pointer">
                                        xóa
                                      </span>
                                    </div>
                                  </figcaption>
                                </figure>
                              ))}
                            </div>
                            {imageURLS.length <= 10 && (
                              <Button onClick={onButtonClickFileImage}>CHỌN HÌNH ẢNH (KHÔNG VIDEO)</Button>
                            )}
                          </div>
                        </div>
                      )}
                      {openComment?.two && (
                        <div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>++ Bổ sung Sổ, giấy tờ ?</b>
                          </label>
                          <span className="text-xs">Chỉ liên quan tới Sổ, giấy tờ</span>

                          <div>
                            <div className="col-span-2">
                              <input
                                type="file"
                                // accept="image/*"
                                multiple
                                name="image"
                                id="file"
                                ref={inputFileSo}
                                style={{ display: 'none' }}
                                onChange={onFilechangeSo}
                              />{' '}
                              <div className="grid grid-cols-2 gap-4">
                                {imageURLSSo?.map((imageSrc, i) => (
                                  <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                                    {imageSrc ? (
                                      <img src={imageSrc} alt="not fount" width={'100%'} />
                                    ) : (
                                      <a href={URL.createObjectURL(imagesSo[i])} download={imagesSo[i].name}>
                                        {imagesSo[i].name}
                                      </a>
                                    )}
                                    <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                                      <div>
                                        <span onClick={() => removeImageSo(i)} className="cursor-pointer">
                                          xóa
                                        </span>
                                      </div>
                                    </figcaption>
                                  </figure>
                                ))}
                              </div>
                              {imageURLSSo.length <= 5 && (
                                <Button onClick={onButtonClickFileImageSo}>
                                  CHỌN SỔ: HÌNH ẢNH, TẬP TIN (KHÔNG VIDEO)
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {openComment?.three && (
                        <div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nhập SĐT kèm Tên Chủ mới</b>
                          </label>
                          <Input
                            value={arrBDS?.sdtchudat}
                            placeholder="VD: 0912345678 Viet Nam "
                            className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, sdtchudat: e.target.value });
                              setWarningMessagePhone('');
                            }}
                          />
                          <div className="text-[10px] font-bold mb-1">Theo mẫu: 0912345678 Viet Nam</div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3 text-blue-500">
                            <b>Chọn vai trò chủ đất</b>
                          </label>
                          <Select
                            label="Chọn vai trò"
                            value={arrBDS?.sdtchudatvaitro}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, sdtchudatvaitro: e });
                              setWarningMessagePhone('');
                            }}
                            containerProps={{
                              className: 'min-w-[0px!important]',
                            }}
                          >
                            {Array.isArray(listVaiTro) &&
                              listVaiTro.filter(Boolean).map((row, idx) => (
                                <Option key={row.value} value={row.value}>
                                  {row.name}
                                </Option>
                              ))}
                          </Select>
                          {warningMessagePhone && (
                            <div className="text-[13px] font-bold text-red-500">{warningMessagePhone}</div>
                          )}
                        </div>
                      )}

                      {openComment?.five && (
                        <div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nhập Diện tích đất ở</b>
                          </label>
                          <Input
                            value={arrBDS?.dientich}
                            placeholder="VD: 200m2 nhập 200 "
                            className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, dientich: e.target.value });
                            }}
                          />
                          {/* <div className="text-[10px] font-bold">Theo mẫu: 0912345678 Viet Nam</div> */}
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nhập Diện tích đất nông nghiệp</b>
                          </label>
                          <Input
                            value={arrBDS?.dientichdatnn}
                            placeholder="VD: 200m2 nhập 200 "
                            className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, dientichdatnn: e.target.value });
                            }}
                          />
                          {/* nhập Số tầng */}
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nhập Số tầng</b>
                          </label>
                          <Input
                            value={arrBDS?.sotang}
                            placeholder="VD: 5 tâng nhập 5 "
                            className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, sotang: e.target.value });
                            }}
                          />

                          {/* nhập Số phòng */}
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nhập Số phòng</b>
                          </label>
                          <Input
                            value={arrBDS?.sophong}
                            placeholder="VD: 6 phòng nhập 6 "
                            className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, sophong: e.target.value });
                            }}
                          />
                          {/* nhập loại vị trí */}
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nhập Loại Vị trí (MT, Hẻm...)</b>
                          </label>
                          <div>
                            <div className="relative">
                              <button
                                className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-xl shadow-sm"
                                onClick={() => {
                                  handleOpen(8);
                                  getLoaiVitri();
                                }}
                              >
                                {' '}
                                {arrBDS && arrBDS.loaivitri ? (
                                  <span className="mr-2 grid grid-cols-2 gap-2">
                                    {arrBDS.loaivitri?.split(',')?.map((row, i) => (
                                      <Chip
                                        value={row}
                                        variant="ghost"
                                        icon={<XCircleIcon />}
                                        key={i}
                                        onClick={() => removeDataBds(arrBDS.loaivitri?.split(','), 'loaivitri', i)}
                                      />
                                    ))}
                                  </span>
                                ) : (
                                  <span className="mr-2">Nhấn, Có thể chọn nhiều...</span>
                                )}
                              </button>
                              {open === 8 && (
                                <div
                                  className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                                >
                                  <Input
                                    // value={''}

                                    className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                                    labelProps={{
                                      className: 'hidden',
                                    }}
                                    onChange={(e) => handleSearchOptionSelect('loaivitri', e.target.value, 'name')}
                                  />

                                  <div className="pl-1">
                                    <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                                  </div>
                                  {arrOptionSelectSearch?.loaivitri &&
                                    arrOptionSelectSearch?.loaivitri.map((row, index) => (
                                      <div
                                        className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                        key={index}
                                        onClick={() => {
                                          if (!checkText(arrBDS.loaivitri, row?.name)) {
                                            setArrBDS({
                                              ...arrBDS,
                                              loaivitri: `${arrBDS['loaivitri'] ? arrBDS['loaivitri'] + ',' : ''}${
                                                row?.name
                                              }`,
                                            });
                                            setIsChangeData({
                                              ...isChangeData,
                                              'loại vị trí': `${arrBDS['loaivitri'] ? arrBDS['loaivitri'] + ',' : ''}${
                                                row?.name
                                              }`,
                                            });
                                            handleOpen(0);
                                          }
                                        }}
                                      >
                                        <b
                                          className={`${checkText(arrBDS.loaivitri, row?.name) ? 'text-gray-500' : ''}`}
                                        >
                                          {row?.name}
                                        </b>
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          </div>

                          <div>
                            <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                              <b>Nhập Loại BĐS</b>
                            </label>

                            <div className="relative">
                              <button
                                className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-400 rounded-md shadow-sm"
                                onClick={() => {
                                  handleOpen(9);
                                  getLoaiBDS();
                                }}
                              >
                                {' '}
                                {arrBDS && arrBDS.loaibds ? (
                                  <span className="mr-2 grid grid-cols-2 gap-2">
                                    {arrBDS.loaibds?.split(',')?.map((row, i) => (
                                      <Chip
                                        value={row}
                                        variant="ghost"
                                        icon={<XCircleIcon />}
                                        key={i}
                                        onClick={() => removeDataBds(arrBDS.loaibds?.split(','), 'loaibds', i)}
                                      />
                                    ))}
                                  </span>
                                ) : (
                                  <span className="mr-2">Nhấn, Có thể chọn nhiều...</span>
                                )}
                              </button>
                              {open === 9 && (
                                <div
                                  className={`absolute right-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 w-full z-10`}
                                >
                                  <Input
                                    // value={''}

                                    className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                                    labelProps={{
                                      className: 'hidden',
                                    }}
                                    onChange={(e) => handleSearchOptionSelect('loaibds', e.target.value, 'name')}
                                  />

                                  <div className="pl-1">
                                    <b className="text-sm">vui lòng nhập thêm từ 1 ký tự trở lên</b>
                                  </div>
                                  {arrOptionSelectSearch?.loaibds &&
                                    arrOptionSelectSearch?.loaibds.map((row, index) => (
                                      <div
                                        className="block px-2 text-gray-700 hover:bg-gray-100 active:bg-blue-100 cursor-pointer rounded-md"
                                        key={index}
                                        onClick={() => {
                                          if (!checkText(arrBDS.loaibds, row?.name)) {
                                            setArrBDS({
                                              ...arrBDS,
                                              loaibds: `${arrBDS['loaibds'] ? arrBDS['loaibds'] + ',' : ''}${
                                                row?.name
                                              }`,
                                            });
                                            setIsChangeData({
                                              ...isChangeData,
                                              'loại bđs': `${arrBDS['loaibds'] ? arrBDS['loaibds'] + ',' : ''}${
                                                row?.name
                                              }`,
                                            });
                                            handleOpen(0);
                                          }
                                        }}
                                      >
                                        <b className={`${checkText(arrBDS.loaibds, row?.name) ? 'text-gray-500' : ''}`}>
                                          {row?.name}
                                        </b>
                                      </div>
                                    ))}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      {openComment?.four && (
                        <div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Lên lịch nhắc nhở</b>
                          </label>
                          <Input
                            value={arrBDS?.nhaclich}
                            placeholder="dd/mm/yy"
                            className="w-full rounded-xl !border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            type="date"
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, nhaclich: e.target.value });
                            }}
                          />
                        </div>
                      )}

                      {openComment?.six && (
                        <div>
                          <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                            <b>Nội dung cập nhật Quy Hoạch XD</b>
                          </label>

                          <Textarea
                            value={arrBDS?.qhxd}
                            type="text"
                            className="!border !border-gray-400 bg-white text-gray-900 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100"
                            labelProps={{
                              className: 'hidden',
                            }}
                            onChange={(e) => {
                              setArrBDS({ ...arrBDS, qhxd: e.target.value });
                            }}
                          />

                          <div>
                            <label className="flex items-end gap-1 text-xs mb-1 mt-3">
                              <b>++ Thêm Hình QHXD ?</b>
                            </label>
                            <span className="text-sm">Chỉ hình ảnh Quy Hoạch Xây Dựng</span>

                            <div>
                              <input
                                type="file"
                                accept="image/*"
                                multiple
                                name="image"
                                id="file"
                                ref={inputFileQhxd}
                                style={{ display: 'none' }}
                                onChange={onFilechangeQHXD}
                              />{' '}
                              <div className="grid lg:grid-cols-2 gap-4 mb-1">
                                {imageURLSQhxd?.map((imageSrc, i) => (
                                  <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                                    <img src={imageSrc} alt="not fount" width={'100%'} />
                                    <figcaption className="absolute bottom-4 left-2/4 flex px-1 -translate-x-2/4 justify-center rounded-xl border border-white bg-red-900 text-white shadow-lg shadow-black/5 saturate-200 backdrop-blur-sm">
                                      <div>
                                        <span onClick={() => removeImageQHXD(i)} className="cursor-pointer">
                                          xóa
                                        </span>
                                      </div>
                                    </figcaption>
                                  </figure>
                                ))}
                              </div>
                              {imageURLS.length <= 4 && (
                                <Button onClick={onButtonClickFileImageQhxd} color="blue">
                                  CHỌN HÌNH ẢNH QHXD (KHÔNG VIDEO)
                                </Button>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="text-xs font-bold mt-2">Tuy chọn thêm</div>
                      <div>
                        <Checkbox
                          color="blue"
                          label={<span className="font-bold text-gray-800">Thêm Hình Sản Phẩm</span>}
                          containerProps={{
                            className: 'mt-1, p-2',
                          }}
                          checked={openComment?.one}
                          onChange={() => {
                            setOpenComment({ ...openComment, one: !openComment.one });
                          }}
                        />
                      </div>
                      <div>
                        <Checkbox
                          color="blue"
                          label={<span className="font-bold text-gray-800">Thêm Sổ, giấy tờ BĐS</span>}
                          containerProps={{
                            className: 'mt-1, p-2',
                          }}
                          checked={openComment?.two}
                          onChange={() => {
                            setOpenComment({ ...openComment, two: !openComment.two });
                          }}
                        />
                      </div>
                      <div>
                        <Checkbox
                          color="blue"
                          label={<span className="font-bold text-gray-800">Thêm SĐT liên hệ, chủ nhà</span>}
                          containerProps={{
                            className: 'mt-1, p-2',
                          }}
                          checked={openComment?.three}
                          onChange={() => setOpenComment({ ...openComment, three: !openComment.three })}
                        />
                      </div>
                      <div>
                        <Checkbox
                          color="blue"
                          label={
                            <span className="font-bold text-gray-800">
                              Cập nhật diện tích, số phòng/tầng, Loại vị trí…
                            </span>
                          }
                          containerProps={{
                            className: 'mt-1, p-2',
                          }}
                          checked={openComment?.five}
                          onChange={() => setOpenComment({ ...openComment, five: !openComment.five })}
                        />
                      </div>
                      <div>
                        <Checkbox
                          color="blue"
                          label={<span className="font-bold text-gray-800">Lên lịch nhắc nhở?</span>}
                          containerProps={{
                            className: 'mt-1, p-2',
                          }}
                          checked={openComment?.four}
                          onChange={() => setOpenComment({ ...openComment, four: !openComment.four })}
                        />
                      </div>
                      {auth?.username === 'admin' && (
                        <div>
                          <Checkbox
                            color="blue"
                            label={<span className="font-bold text-gray-800">Cập nhật Quy Hoạch Xây Dựng</span>}
                            containerProps={{
                              className: 'mt-1, p-2',
                            }}
                            checked={openComment?.six}
                            onChange={() => setOpenComment({ ...openComment, six: !openComment.six })}
                          />
                        </div>
                      )}
                      <div>
                        <Button color="orange" size="sm" className="mt-3" onClick={subComment}>
                          Gửi Cập Nhật
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {resultListBds?.bl?.length > 0 && (
              <div className={`lg:col-span-3 bg-white rounded-2xl`}>
                <div
                  className="border-[6px] border-gray-100 rounded-2xl"
                  style={{ boxShadow: 'rgba(0, 0, 0, 0.26) 0px 5px 15px' }}
                >
                  {' '}
                  <div className="border border-dashed border-green-500 rounded-2xl">
                    <div className="flex items-center bg-green-400 rounded-2xl p-2 font-bold text-white">
                      <MinusIcon className="h-5 w-5" /> LỊCH SỬ CẬP NHẬT
                    </div>

                    <div className="p-2">
                      {resultListBds?.bl?.map((row, i) => (
                        <p key={i} className="flex-col items-center mb-1">
                          <b className="flex items-center text-sm">
                            <UserIcon className="w-5 h-5 mr-1" />{' '}
                            <label className={`${isOldData(row?.is_user) ? 'text-gray-400' : ''}`}>
                              {isOldData(row?.is_user) ? 'Old Data' : row?.username}
                            </label>{' '}
                            - {row?.update_date?.split('T')[1]} - {row?.update_date?.split('T')[0]}:
                          </b>
                          <span className="flex ml-4 text-sm">
                            {row?.gia > 0
                              ? parseInt(resultListBds?.gia) > parseInt(row?.gia)
                                ? ` đã GIẢM ${convertNumberToWords(
                                    parseInt(resultListBds?.gia),
                                  )} còn ${convertNumberToWords(row?.gia)}`
                                : ` đã TĂNG ${convertNumberToWords(
                                    parseInt(resultListBds?.gia),
                                  )} lên ${convertNumberToWords(row?.gia)}`
                              : ''}
                            {row?.noidung ? ' - ' + row?.noidung : ''}
                            {row?.sdtchudat ? ' - đã thêm số chủ đất' : ''}
                            {row?.dientich ? ' - đã thêm diện tích thổ cư' : ''}
                            {row?.dientichdatnn ? ' - đã thêm diện tích nông nghiệp' : ''}
                            {row?.loaivitri ? ' - đã thêm loại vị trí' : ''}
                            {row?.loaibds ? ' - đã thêm loại bđs' : ''}
                            {row?.sotang ? ' - đã thêm số tầng' : ''}
                            {row?.sophong ? ' - đã thêm số phòng' : ''}
                            {row?.anh ? ' - đã thêm ảnh' : ''}
                            {row?.anhso ? ' - đã thêm ảnh sổ' : ''}
                            {row?.qhxd ? ' - Đã cập nhật quy hoạch XD ' : ''}
                            {row?.nhaclich
                              ? ' - đã nhắc nhở ' + new Date(row?.nhaclich).toLocaleDateString() + ' hết hạn bán'
                              : ''}
                            {auth?.username === 'admin' && (
                              <TrashIcon
                                color="red"
                                className="h-5 w-5 cursor-pointer"
                                onClick={() => removeCmt(row?.id)}
                              />
                            )}
                          </span>

                          <hr className="my-2 border-blue-gray-50" />
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="mt-4 ">
              <div className="flex justify-center">
                <h2 className="font-bold text-2xl mb-2">BĐS Tương Tự</h2>
                <div className="lg:max-w-xs lg:w-full ml-2">
                  <div className="relative">
                    <select
                      onChange={(e) => {
                        countTinLienQuanTuongTu(e.target.value, resultListBds.gia, resultListBds.loaibds);
                      }}
                      className="w-full border-gray-400 rounded-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                    >
                      {arrSapxep.map((row, i) => (
                        <option key={i} value={row.value}>
                          {row.title}
                        </option>
                      ))}
                    </select>
                    <ChevronUpDownIcon className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700" />
                  </div>
                </div>
              </div>
              {resultTuongtu.length > 0 &&
                resultTuongtu?.map((row, i) => (
                  <div key={i}>
                    {' '}
                    <FrameShowBds data={row} yeuthich={isYeuThich} Avt={row.avt} showImages={showImagesTuongtu[i]} />
                  </div>
                ))}
            </div>

            <div className="mt-4 ">
              <div className="flex justify-center">
                <h2 className="font-bold text-2xl mb-2">BĐS Gần Vị Trí</h2>
                <div className="lg:max-w-xs lg:w-full ml-2">
                  <div className="relative">
                    <select
                      onChange={(e) => {
                        countTinLienQuanGanViTri(e.target.value, resultListBds.gia, resultListBds.xa);
                      }}
                      className="w-full border-gray-400 rounded-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 pl-3 pr-8 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-400 shadow-sm focus:shadow-md appearance-none cursor-pointer"
                    >
                      {arrSapxep.map((row, i) => (
                        <option key={i} value={row.value}>
                          {row.title}
                        </option>
                      ))}
                    </select>
                    <ChevronUpDownIcon className="h-5 w-5 ml-1 absolute top-2.5 right-2.5 text-slate-700" />
                  </div>
                </div>
              </div>
              {resultGanVitri.length > 0 &&
                resultGanVitri?.map((row, i) => (
                  <div key={i}>
                    {' '}
                    <FrameShowBds data={row} yeuthich={isYeuThich} Avt={row.avt} showImages={showImagesViTri[i]} />
                  </div>
                ))}
            </div>
          </div>
        </>
      ) : loading ? (
        <div className="flex justify-center">
          <b>BÀI VIẾT KHÔNG TỒN TẠI</b>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="lg:col-span-3">
            <LoadingFrame />
          </div>
        </div>
      )}
    </div>
  );
}
